export function MacroBar({ label, value = 0, goal = 0, color, unit = "g", testid }) {
  const pct = Math.min(100, goal > 0 ? (value / goal) * 100 : 0);
  return (
    <div className="rounded-2xl bg-card border border-border p-4" data-testid={testid}>
      <div className="flex items-center justify-between mb-2.5">
        <span className="text-sm font-semibold text-foreground/80">{label}</span>
        <span className="w-2.5 h-2.5 rounded-full" style={{ background: color }} />
      </div>
      <div className="flex items-baseline gap-1 mb-2">
        <span className="text-xl font-display font-medium tabular-nums">{Math.round(value)}</span>
        <span className="text-xs text-muted-foreground">/ {Math.round(goal)}{unit}</span>
      </div>
      <div className="h-1.5 rounded-full bg-muted overflow-hidden">
        <div
          className="h-full rounded-full"
          style={{ width: `${pct}%`, background: color, transition: "width 0.7s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </div>
    </div>
  );
}
